export const pruneUrlFromUnnecessaryCharacters = (url: string) =>
  url.replace(/\\\//g, '/').trim();
